import React, { useState } from "react"

import { IconRotatingChevron } from "../../../common/IconRotatingChevron"
import MatchIndicator from "./MatchIndicator"
import styles from "./CollapsibleSection.module.css"

type Props = {
  title: string
  summary: string
  score?: number
  children?: React.ReactNode
}

const CollapsibleSection = ({ title, summary, score, children }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleSection = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader} onClick={toggleSection}>
        <MatchIndicator score={score} />
        <div className={styles.sectionTitle}>{title}</div>
        <div className={styles.sectionSummary}>
          {summary && <span className={styles.summaryText}>{summary}</span>}
        </div>
        <IconRotatingChevron
          direction={isExpanded ? "down" : "right"}
          size={16}
          className={styles.chevron}
        />
      </div>
      {isExpanded && children && (
        <div className={styles.sectionContent}>{children}</div>
      )}
    </div>
  )
}

export default CollapsibleSection
